module.exports = __webpack_public_path__ + "static/media/aaa-award.1437bf1b.png";